import {
  ACTIVITIES_SHOP_OPTION,
  ActivitiesDetailsProperties,
  ExperienceBookableItem,
  ExperiencesShopOptionResponse,
  ITrackingProperties,
} from "redmond";
import { put, select } from "redux-saga/effects";
import { actions } from "../actions";
import Logger from "../../../utils/logger";
import { fetchExperienceShopOptions } from "../../../api/v0/shop/fetchExperiencesShopOptions";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";
import {
  getActivityDetailsProperties,
  getSelectedBookableItem,
} from "../reducer";
import { handleEncryptedProperties } from "../../../utils/encryptedPropertiesUtils";

export function* fetchExperiencesShopOptionsSaga(
  action: actions.IFetchExperiencesShopOptions,
) {
  const activityDetailsProperties: ITrackingProperties<ActivitiesDetailsProperties> =
    yield select(getActivityDetailsProperties);
  const { properties, encryptedProperties } = activityDetailsProperties;

  const selectedBookableItem: ExperienceBookableItem | null = yield select(
    getSelectedBookableItem,
  );

  let shopContext;
  try {
    const localStoredShopContext = localStorage.getItem(
      `shop-context-${action.request.experienceId.value}`,
    );
    if (localStoredShopContext) {
      shopContext = JSON.parse(localStoredShopContext);
    }
  } catch (e) {
    Logger.debug(e);
  }

  try {
    const shopOptionsResponse: ExperiencesShopOptionResponse =
      yield fetchExperienceShopOptions({
        ...action.request,
        shopContext,
      });

    const opaqueActivityToken = shopOptionsResponse.opaqueActivityToken;

    // Enhance tracking properties with activity_option_name and option_code
    const enhancedTrackingProperties = {
      ...shopOptionsResponse.trackingProperties,
      properties: {
        ...shopOptionsResponse.trackingProperties.properties,
        activity_option_name: selectedBookableItem?.title,
        option_code: selectedBookableItem?.experienceOptionId?.value,
      },
    };

    if (shopOptionsResponse.breakdowns.length !== 0) {
      yield put(
        actions.setExperiencesShopOptions(
          shopOptionsResponse.breakdowns.map((breakdown) => ({
            ...breakdown,
            date: action.request.date,
          })),
          enhancedTrackingProperties,
          opaqueActivityToken,
          shopOptionsResponse.bestTravelOffer,
        ),
      );
    } else {
      // set shop options to empty, which means no availability
      yield put(
        actions.setExperiencesShopOptions(
          [],
          enhancedTrackingProperties,
          undefined,
          shopOptionsResponse.bestTravelOffer,
        ),
      );
    }

    trackEvent({
      eventName: ACTIVITIES_SHOP_OPTION,
      properties: {
        ...properties,
        ...enhancedTrackingProperties.properties,
        success: true,
      },
      encryptedProperties: [
        ...handleEncryptedProperties(encryptedProperties),
        ...handleEncryptedProperties(
          enhancedTrackingProperties.encryptedProperties,
        ),
      ],
    });
  } catch (e) {
    trackEvent({
      eventName: ACTIVITIES_SHOP_OPTION,
      properties: {
        ...properties,
        success: false,
        activity_option_name: selectedBookableItem?.title,
        option_code: selectedBookableItem?.experienceOptionId?.value,
      },
      encryptedProperties: handleEncryptedProperties(encryptedProperties),
    });
    yield put(actions.setExperiencesShopOptionsCallStateFailed());
    Logger.debug(e);
  }
}
